import slotTypesConfig from './slot-types-config.json';

export default function getSlotTypes(sportId, groupType, outcomeType) {
    try {
        const slotTypes = slotTypesConfig[sportId][groupType][outcomeType];

        if (slotTypes === undefined) {
            console.warn(`Cannot find slot types for sport#${sportId}, group#${groupType} outcome#${outcomeType}`);//eslint-disable-line no-console
        }

        return slotTypes || [outcomeType];
    }
    catch (e) {
        console.log(`Cant find slot type for sport#${sportId}, group#${groupType} outcome#${outcomeType}:`, e);//eslint-disable-line no-console
    }

    return [outcomeType];
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/providers/SlotTypeProvider.js